import { Button, Input, Modal, Space, Steps, Table, Tag } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { PlusCircle } from "react-feather";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Card, CardBody } from "reactstrap";
import { H5 } from "../../../../AbstractElements";
import { CashFlowApi, PoWoApi, TaxOptionAPI } from "../../../../api";
import { fetchOrganisationDetails } from "../../../../api/organisation.api";
import { LogEvents, LoggerContext } from "../../../../context/logging";
import { poCreationAndEditGranted } from "../../../../utils/PermissionFunctions/userPermissions";
import { getTableHeight } from "../../../../utils/TableHelpers/TableHeightHelper";
import { useAPIUser } from "../../../../_helper/User/UserProvider";
import ColumnConfig from "../Budget/column-config";
import "../stylesManipulated.css";
import SearchFilter from "./searchFilter";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});

const PO = (props) => {
  const location = useLocation();
  const logger = React.useContext(LoggerContext);
  const { Step } = Steps;
  const history = useNavigate();
  const { user } = props.settings;
  const { userDetails, setUserDetails } = useAPIUser();
  const [poList, setPoList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [createdByMembers, setCreatedByMembers] = useState([]);
  const [taxOptions, setTaxOptions] = useState([]);
  const [organisationDetails, setOrganisationDetails] = useState(null);
  const [modal1Visible, setModal1Visible] = useState(false);
  const [modal2Visible, setModal2Visible] = useState(false);
  const [track, setTrack] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [poDetails, setPoDetails] = useState(null);
  const [search, setSearch] = useState("");

  const fetchTaxOptions = () => {
    axios.get(`${TaxOptionAPI}`).then((res) => {
      setTaxOptions(
        res.data?.filter(
          (each) =>
            each.organisation === userDetails?.organisation?.organisation_id
        )
      );
    });
  };
  const fetchPos = (params = {}) => {
    const {
      settings: { project },
    } = props;
    setLoading(true);
    axios
      .get(`${PoWoApi}`, { params: { ...params } })
      .then((res) => {
        setPoList(
          res.data?.map((po) => {
            let status = "Pending";
            if (po?.is_deleted) {
              status = "Discarded";
            } else if (!po?.is_approved) {
              if (po?.is_decline) {
                status = "Rejected";
              } else {
                status = "Pending";
              }
            } else {
              status = "Raised";
            }
            return {
              ...po,
              currentStatus: status,
            };
          })
        );
        let vendors = [];
        let createdByList = [];
        res?.data?.map((po) => {
          if (
            vendors.findIndex((vendor) => vendor.text == po.vendor?.name) < 0
          ) {
            vendors.push({
              text: po.vendor?.name,
              value: po.vendor?.name,
            });
          }
          if (
            createdByList.findIndex((member) => member.text == po.created_by) <
            0
          ) {
            createdByList.push({
              text: po.created_by,
              value: po.created_by,
            });
          }
        });
        setCreatedByMembers(createdByList);
        setVendors(vendors);
        setLoading(false);
      })
      .catch(() => {
        toast.error("Something went wrong!");
      });
  };
  const getOrganisationDetails = () => {
    fetchOrganisationDetails().then((res) => {
      setOrganisationDetails(res);
    });
  };
  const onEdit = (id) => {
    history(`/app/project/powo/edit/` + id, {
      state: { editId: id },
    });
  };
  const onDelete = (id) => {
    const formData = new FormData();
    formData.append("is_deleted", true);
    axios
      .put(`${PoWoApi}${id}/`, formData)
      .then((res) => {
        toast.success("Successfully deleted PO!");
        fetchPos({ is_deleted: false });
      })
      .catch(() => {
        toast.error("Something went wrong!");
      });
  };
  const showStatus = (po) => {
    var trackNew = [];
    var createdAt = moment(po?.created_at);
    const formattedDate =
      moment(createdAt).format("ddd") +
      " " +
      moment(createdAt).format("MMM") +
      " " +
      moment(createdAt).format("DD") +
      " " +
      moment(createdAt).format("YYYY");
    var firstStep = {
      step: "PO Raised",
      description: formattedDate,
    };
    trackNew.push(firstStep);
    var steps = po?.approval_flow;
    var stepsCompleted = 1;
    for (var i = 0; i < steps?.length; i++) {
      if (steps[i]?.is_approved) stepsCompleted += 1;
      var newStep = {
        step: steps[i]?.project_member__user_organisation__user__name,
        description: steps[i]?.is_approved ? "Approved" : "Approval Pending",
      };
      trackNew.push(newStep);
    }
    var finalStep = {
      step: "PO Status",
      description: !po.is_approved
        ? po?.is_decline
          ? "Rejected"
          : "Pending"
        : "Approved",
    };
    trackNew.push(finalStep);
    if (po.is_approved) {
      stepsCompleted = 1 + steps.length;
    }
    setCurrentStep(stepsCompleted);
    setTrack(trackNew);
  };
  useEffect(() => {
    logger.log(LogEvents.projectPoWo, {});
    fetchPos({ project: props.settings?.project?.id });
    fetchTaxOptions();
    getOrganisationDetails();

    // const columnSettings = [...userSelectedColumns];

    // if (props.settings?.organisation?.lead_field) {
    //   columnSettings.splice(1, 0, {
    //     title: "Lead ID",
    //     key: "lead_id",
    //     dataIndex: "lead_id",
    //     fixed: "left",
    //   });
    //   setUserSelectedColumns(columnSettings);
    // }
  }, []);

  useEffect(() => {
    console.log("searcj", search);
    fetchPos({ project: props.settings?.project?.id, search: search });
  }, [search]);

  const getFormattedDate = (date) => {
    const formattedDate =
      // moment(date).format("ddd") +
      // " " +
      moment(date).format("MMM") +
      " " +
      moment(date).format("DD") +
      " " +
      moment(date).format("YYYY");

    return formattedDate;
  };
  const getTypeOfOrder = (type) => {
    if (type == "po") {
      return "PO";
    }
    if (type == "internal") {
      return "Internal";
    }
    if (type == "estimate") {
      return "Estimate";
    }
    if (type == "WO") {
      return "WO";
    } else {
      return "PO";
    }
  };
  const columns = [
    // {
    //   title: "Po ID#",
    //   key: "id",
    //   dataIndex: "id",
    // },
    {
      title: "Po No.",
      key: "po_number",
      dataIndex: "po_number",
      fixed: "left",
    },
    {
      title: "Vendor Name",
      key: "vendor",
      width: 170,
      sortType: "string",
      sorter: (a, b) => {
        return a.vendor.name.localeCompare(b.vendorName);
      },
      filters: vendors,
      onFilter: (value, record) => record.vendor.name.indexOf(value) === 0,
      render: (data) => <span>{data?.vendor?.name}</span>,
    },
    {
      title: "Delivery Date",
      key: "delivery_date",
      sortType: "date",
      dateFormat: "MMM DD YYYY",
      sorter: (a, b) => {
        return a.delivery_date.localeCompare(b.delivery_date);
      },
      render: (data) => <span>{getFormattedDate(data?.delivery_date)}</span>,
    },
    {
      title: "Creation Date",
      key: "created_at",
      sorter: (a, b) => {
        return a.created_at.localeCompare(b.created_at);
      },
      sortType: "date",
      dateFormat: "MMM DD YYYY",
      render: (data) => <span>{getFormattedDate(data?.created_at)}</span>,
    },
    {
      title: "Created By",
      key: "created_by",
      dataIndex: "created_by",
      filters: createdByMembers,
      onFilter: (value, record) => record.created_by.indexOf(value) === 0,
      sorter: (a, b) => {
        return a.created_by.localeCompare(b.created_by);
      },
    },
    {
      title: "Order Type",
      key: "type_of_order",
      sorter: (a, b) => {
        return a.type_of_order.localeCompare(b.type_of_order);
      },
      filters: [
        {
          text: "PO",
          value: "po",
        },
        {
          text: "WO",
          value: "wo",
        },
        {
          text: "INTERNAL",
          value: "internal",
        },
        {
          text: "ESTIMATE",
          value: "estimate",
        },
      ],
      onFilter: (value, record) => record.type_of_order.indexOf(value) === 0,

      render: (data) => <span>{getTypeOfOrder(data?.type_of_order)}</span>,
    },
    {
      title: "Status",
      key: "currentStatus",
      sorter: (a, b) => {
        return a.currentStatus.localeCompare(b.currentStatus);
      },
      filters: [
        {
          text: "Pending",
          value: "Pending",
        },
        {
          text: "Discarded",
          value: "Discarded",
        },
        {
          text: "Rejected",
          value: "Rejected",
        },
        {
          text: "Raised",
          value: "Raised",
        },
      ],
      onFilter: (value, record) => record.currentStatus.indexOf(value) === 0,
      render: (data) => (
        <>
          {data?.is_deleted ? (
            <Tag color={"error"}>Discarded</Tag>
          ) : !data?.is_approved ? (
            data?.is_decline ? (
              <Tag color={"error"}>Rejected</Tag>
            ) : (
              <Tag color={"warning"}>Pending</Tag>
            )
          ) : (
            <Tag color={"success"}>Raised</Tag>
          )}
        </>
      ),
    },
    {
      title: "Total",
      key: "total_po_raised_amount",
      render: (data) => (
        <>{parseFloat(data?.total_po_raised_amount ?? 0)?.toFixed(2)}</>
      ),
    },
    {
      title: "Actions",
      key: "action",
      render: (data) => (
        <Space>
          {/* {data?.is_deleted ? null : (
            <Tag
              onClick={() => {
                generatePdf(
                  data,
                  taxOptions,
                  organisationDetails?.organisation_logo
                );
              }}
              color={"purple"}
              style={{ cursor: "pointer" }}
            >
              Print Reciept
            </Tag>
          )} */}
          {/* {data?.is_deleted ? null : (
            <Tag
              onClick={() => {
                onEdit(data.id);
                showStatus(data);
              }}
              color={"warning"}
              style={{ cursor: "pointer" }}
            >
              Edit Details
            </Tag>
          )} */}
          {/* <Tag
            onClick={() => {
              showStatus(data);
            }}
            color={"success"}
            style={{ cursor: "pointer" }}
          >
            Status
          </Tag> */}
          <Tag
            onClick={() => {
              // setModal2Visible(true);
              // setPoDetails(data);

              logger.log(LogEvents.seeDetailsPoWo, {});
              history("/app/project/po-details/" + data?.id, {
                state: {
                  details: data,
                  organisationDetails: organisationDetails,
                  projectDetails: props.settings.project,
                  taxOptions: taxOptions,
                },
              });
            }}
            color={"volcano"}
            style={{ cursor: "pointer" }}
          >
            See Details
          </Tag>
          {/* {data?.is_deleted ? null : (
            <Popconfirm
              onConfirm={() => {
                onDelete(data.id);
              }}
              okText={"Yes"}
              cancelText={"No"}
              title={"Are you sure to delete?"}
            >
              <Tag style={{ cursor: "pointer" }} color={"error"}>
                Delete
              </Tag>
            </Popconfirm>
          )} */}
        </Space>
      ),
    },
  ];

  const [userSelectedColumns, setUserSelectedColumns] = useState(columns);

  useEffect(() => {
    if (props.settings?.user?.user_selected_columns?.powo_table) {
      const columnSettings = userSelectedColumns?.map((col) => {
        let currentCol =
          props.settings?.user?.user_selected_columns?.powo_table?.find(
            (column) => col.key == column?.key
          );
        return { ...col, selected: currentCol?.selected ?? true };
      });

      setUserSelectedColumns(columnSettings);
    }
  }, [props.settings?.user?.user_selected_columns?.powo_table]);
  const getUserSelectedColumns = () => {
    return userSelectedColumns
      .filter((column) => {
        return column?.selected !== false;
      })
      .map((column) => {
        return columns.find((col) => {
          return col.key === column.key;
        });
      })
      .filter((col) => Boolean(col));
  };

  return (
    <>
      <div>
        <Card>
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="">
                <H5>All POs/WOs</H5>
              </div>
            </div>
            {/* <SearchFilter
              fetchPo={fetchPos}
              project_id={props.settings?.project?.id}
            /> */}
            <section
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Space>
                {poCreationAndEditGranted(props.settings?.user) && (
                  <Button
                    className="btn btn-primary d-flex align-items-center justify-content-center text-white"
                    onClick={() => {
                      logger.log(LogEvents.createPoWo, {});
                      history(`/app/project/powo/new`, {
                        state: { editId: null },
                      });
                    }}
                  >
                    {" "}
                    <PlusCircle />
                    <div
                      style={{
                        marginLeft: "4px",
                        paddingTop: "4px",
                        paddingBottom: "4px",
                      }}
                    >
                      Create PO/WO
                    </div>
                  </Button>
                )}
                <Button
                  className="btn d-flex align-items-center justify-content-center"
                  onClick={() => {
                    window.open(
                      CashFlowApi +
                        "?branch=" +
                        props?.settings?.branch?.id +
                        "&project=" +
                        props.settings?.project?.id,
                      "_blank"
                    );
                  }}
                >
                  <div
                    style={{
                      marginLeft: "4px",
                      paddingTop: "4px",
                      paddingBottom: "4px",
                    }}
                  >
                    Download Cash Flow Report
                  </div>
                </Button>
              </Space>
              <Space>
                <Input.Search
                  placeholder="Search..."
                  onSearch={(value) => {
                    setSearch(value);
                  }}
                  style={{ width: 300 }}
                />
                <ColumnConfig
                  columns={userSelectedColumns}
                  setCols={(cols) => setUserSelectedColumns(cols)}
                  mode="powo"
                  onClick={() => {
                    logger.log(LogEvents.customizePoWoMenu, {});
                  }}
                />
              </Space>
            </section>
            <div className="my-2">
              <Table
                loading={loading}
                dataSource={poList}
                columns={getUserSelectedColumns()}
                pagination={{
                  position: "bottomRight",
                }}
                scroll={{
                  x: "100%",
                  y: getTableHeight({ table_name: "po_table" }),
                }}
              />
            </div>
          </CardBody>
        </Card>
      </div>
      <Modal
        title="Track PO Status"
        centered
        visible={modal1Visible}
        onCancel={() => {
          setModal1Visible(false);
        }}
        footer={[
          // <Button
          //   key="submit"
          //   className="btn btn-primary text-white"
          //   htmlType="submit"
          //   loading={loading}
          //   form="stepForm"
          //   onClick={() => {
          //     addStep();
          //   }}
          // >
          //   Submit
          // </Button>,
          <Button
            key="back"
            onClick={() => {
              setModal1Visible(false);
            }}
          >
            Close
          </Button>,
        ]}
      >
        <Steps direction="vertical" size="small" current={currentStep}>
          {track?.map((each, index) => (
            <Step
              key={index}
              title={each?.step}
              description={each?.description}
            />
          ))}
        </Steps>
      </Modal>
      {/* <Modal
        title="PO Details"
        width={"1000px"}
        visible={modal2Visible}
        onCancel={() => {
          setModal2Visible(false);
        }}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setModal2Visible(false);
            }}
          >
            Close
          </Button>,
        ]}
      >
        <PODetails
          details={poDetails}
          organisationDetails={organisationDetails}
          projectDetails={props.settings.project}
          taxOptions={taxOptions}
          track={track}
          currentStep={currentStep}
        />
      </Modal> */}
    </>
  );
};

export default connect(mapStateToProps)(PO);
